export default __webpack_public_path__ + "static/media/icon-setting.933963a2.svg";